// Debug Utilities - Development tools and debug functions for analytics
// Extracted from Analytics.js for better separation of concerns

import { isPreviewOrInternalDomain } from '../../utils/environmentUtils';
import {
  getEventStats,
  getQueueStatus,
  forceProcessQueues,
} from './queueManagement';

/**
 * Initialize debug functions globally in development
 */
export const initializeDebugUtils = () => {
  // Expose debug functions globally in development
  if (
    typeof window !== 'undefined' &&
    (process.env.NODE_ENV === 'development' || isPreviewOrInternalDomain())
  ) {
    window.mixpanelDebug = {
      getStats: getEventStats,
      getQueueStatus: getQueueStatus,
      forceProcessQueues: forceProcessQueues,
      testEvent: testEvent,
    };
  }
};

/**
 * Test event function for debug purposes
 */
const testEvent = (eventName = 'debug_test_event') => {
  // Dynamic import to avoid circular dependency
  import('./eventTracking').then(({ trackEvent }) => {
    trackEvent(eventName, {
      test: true,
      timestamp: new Date().toISOString(),
      debug_source: 'manual_test',
    });
  });
};

/**
 * Update debug queue status functions (called after Mixpanel is ready)
 */
export const updateDebugQueueStatus = () => {
  if (typeof window !== 'undefined' && window.mixpanelDebug) {
    window.mixpanelDebug.getQueueStatus = getQueueStatus;
  }
};
